import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import * as z from "zod";

export const sendTestEmail = {
  name: "sendTestEmail" as const,
  input: z.object({
    emailAddresses: z.array(z.email()),
    template: emailTemplateSchema
      .omit({ _id: true })
      .extend({ _id: z.string().optional() }),
    orderNumber: z.string().optional(),
    /** When set, the test email renders with this recent event's data. */
    eventId: z.string().optional(),
  }),
  output: z.null(),
};
